import { useI18n } from "../../i18n";

const Loader = () => {
  const { t } = useI18n();
  return (
    <div className="f-loader-wrap" style={{ minHeight: "100vh" }}>
      <div className="f-loader-orbit" aria-hidden />
      <div className="f-loader-label">{t("loader.loading")}</div>
    </div>
  );
};

export default Loader;
